import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  groupShops: PropTypes.arrayOf(
    PropTypes.shape({
      groupShopId: PropTypes.number,
      groupId: PropTypes.number,
      groupName: PropTypes.string,
      shopId: PropTypes.number,
      shopName: PropTypes.string,
      status: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const FavoriteShopTableBody = enhance(
  ({ groupShops, emptyRows, page, rowsPerPage, order, orderBy }) => {
    const sortedResult = _.orderBy(groupShops, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(shop => {
            return (
              <TableRow key={shop.groupShopId}>
                <TableCell>{shop.shopName}</TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(FavoriteShopTableBody);
